export default class MonitoramentoAtividadeItem {
    
    constructor(model = null){
        this.id = 0;
        this.monitoramentoAtividadeId = 0;
        this.projetoId = 0;
        this.empresaId = 0;
        this.atividadeId = 0;
        this.atividadeItemId = 0;
        this.resultado = '';
        this.documento = '';
        this.status = 1;

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.monitoramentoAtividadeId = model.monitoramentoAtividadeId;
        this.projetoId = model.projetoId;
        this.empresaId = model.empresaId;
        this.atividadeId = model.atividadeId;
        this.atividadeItemId = model.atividadeItemId;
        this.resultado = model.resultado;
        this.documento = model.documento;
        this.status = model.status;
    }
}